/*global angular */
/*global window */
/*global document */
/*global Image */
/*global FileReader */
/*global alert */
/*jslint node: true */
'use strict';

var behaviors = angular.module('behaviors', []);


behaviors.directive('msImageUpload', ['$templateCache', '$http', 'messages', '$window', 'msAuth', function ($templateCache, $http, messages, $window, msAuth) {
    function readFile($scope, file) {
        var reader = new FileReader();

        reader.onloadend = function () {
            processFile($scope, reader.result, file.type);
        };

        reader.onerror = function () {
            // todo: log There was an error reading the file!
        };

        reader.readAsDataURL(file);
    }

    function processFile($scope, dataURL, fileType) {
        var maxWidth = 1200; // section width TODO: replaced hardcoded value
        var maxHeight = 1800; // maxWidth*1.5

        var image = new Image();
        image.src = dataURL;

        image.onload = function () {
            var width = image.width, height = image.height;
            var shouldResize = (width > maxWidth) || (height > maxHeight);

            if (shouldResize) {
                var newWidth, newHeight;

                if (width > height) {
                    newHeight = height * (maxWidth / width);
                    newWidth = maxWidth;
                } else {
                    newWidth = width * (maxHeight / height);
                    newHeight = maxHeight;
                }

                var canvas = $window.document.createElement('canvas');
                canvas.width = newWidth;
                canvas.height = newHeight;
                var context = canvas.getContext('2d');

                context.drawImage(this, 0, 0, newWidth, newHeight);

                dataURL = canvas.toDataURL(fileType);
                canvas = null;
            }

            $scope.subject[$scope.subjectField] = dataURL;
            $scope.$digest();
            sendFile($scope, dataURL);
        };

        image.onerror = function () {
            // todo: log There was an error processing your file!
        };
    }

    function sendFile($scope, fileData) {
        // todo: start uploading image...
        var payload = {
            domain: $scope.$parent.domain,
            data: fileData
        };

        $http.post('/api/upload', payload, msAuth.request_auth_headers()).success(function (data, status) {
            $scope.subject[$scope.subjectField] = '/uploads/' + data.domain + '/' + data.file_name + '?t=' + Math.random();
            messages.notify('upload-finished');
        }).error(function (data, status) {
            messages.notify('upload-failed');
        });
    }

    return {
        restrict: 'E',
        scope: {
            'subject': '=',
            'subjectField': '='
        },
        link: function ($scope, _element, attrs) {
            if (!window.File || !window.FileReader || !window.FormData) {
                alert("File upload is not supported!"); // TODO
                return;
            }

            var element = _element[0].querySelector('.msImageUpload');
            element.onchange = function (evt) {
                var file = evt.target.files[0];
                if (file && /^image\//i.test(file.type)) {
                    readFile($scope, file);
                } else {
                    // todo: log No or not valid file!
                }
            };
        },
        template: '' +
        '<img ng-src="{{subject[subjectField]}}">' +
        '<div>' +
        '  <md-button class="md-accent md-raised">' +
        '    <md-icon md-font-library="material-icons" class="material-icons">file_upload</md-icon>' +
        '  Durchsuchen</md-button>' +
        '  <input class="msImageUpload" name="file-input" id="file-input" type="file" accept="image/*" aria-label="file_upload" />' +
        '</div>'
    };
}]);


behaviors.directive('autoFocus', function () {
    return {
        restrict: 'AC',
        link: function (_scope, _element) {
            setTimeout(function () {
                _element[0].focus();
            }, 50);
        }
    };
});

behaviors.directive('autoFocusIfNew', function () {
    function selectElementContents(el) {
        var range = document.createRange();
        range.selectNodeContents(el);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
    }

    return {
        restrict: 'AC',
        link: function (_scope, _element) {
            setTimeout(function () {
                if (!_scope.slot) return;

                var selectText = false;
                if (_scope.slot.content == 'Schreiben Sie einfach drauf los...'
                    || _scope.slot.content == 'Headline'
                    || _scope.slot.content == 'Überschrift des ersten Abschnitts'
                    || _scope.slot.content.substr(0, 17) == 'Neue Überschrift ') {
                    selectText = true;
                }

                if (_scope.slot.type == 'headline') {
                    setTimeout(function () {
                        _element[0].focus();
                        if (selectText) {
                            selectElementContents(_element[0]);
                        }
                    }, 50);

                } else {
                    setTimeout(function () {
                        _element[0].childNodes[1].childNodes[2].focus();
                        if (selectText) {
                            selectElementContents(_element[0].childNodes[1].childNodes[2]);
                        }
                    }, 150);
                }
            }, 100);
        }
    };
});

behaviors.directive('autoSelect', function () {
    function selectElementContents(el) {
        var range = document.createRange();
        range.selectNodeContents(el);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
    }

    return {
        restrict: 'AC',
        link: function (_scope, _element) {
            setTimeout(function () {
                selectElementContents(_element[0]);
                setTimeout(function () {
                    _element[0].focus();
                }, 50);
            }, 100);
        }
    };
});

behaviors.directive('contenteditable', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel) {

            function read() {
                ngModel.$setViewValue(element.html());
            }

            ngModel.$render = function () {
                element.html(ngModel.$viewValue || '');
            };

            element.bind('blur keyup change', function () {
                scope.$applyAsync(read);
            });
        }
    };
});


function spawnLinkStuff(e, element) {
    var el = document.createElement('div');
    var text = "link ";
    if (element.target == '_blank') {
        text = "link (verweisend) ";
    }
    el.innerHTML = '<span>' + text + '<a target="_blank" href="' + element.href + '">' + element.href + '</a></span>';
    document.body.appendChild(el);
    el.style.background = 'white';
    el.style.position = 'fixed';
    el.style.left = e.clientX + 'px';
    el.style.top = e.clientY + 'px';
    el.style.padding = "0 0.5em";
    el.style.zIndex = 10000;

    setTimeout(function () {
        angular.element(document).one('click', function () {
            document.body.removeChild(el);
        });
    });
}
function preventLinkAction(e) {
    spawnLinkStuff(e, this);
    e.preventDefault();
}


behaviors.directive('a', ['messages', '$timeout', function (messages, $timeout) {
    return {
        restrict: 'E',
        link: function (scope, elem, attrs) {
            if (!attrs.ngClick && elem[0].target != '_blank') {
                elem[0].onclick = preventLinkAction;
            }
        }
    };
}]);

behaviors.directive('checkLinks', ['messages', '$timeout', function (messages, $timeout) {
    return {
        restrict: 'AE',
        link: function (scope, elem, attrs) {
            setTimeout(function () {
                var elements = elem[0].getElementsByTagName('a');
                for (var i = 0; i < elements.length; i++) {
                    var element = elements[i];
                    if (element.target != '_blank') {
                        element.onclick = preventLinkAction;
                    }
                }
            });
        }
    };
}]);
